import React from 'react';
import './Skills.css'
import node from '../../../Assets/nodejs.png'
import express from '../../../Assets/expressjs.png'
import firebase from '../../../Assets/firebase.png'
import netlify from '../../../Assets/netlify.png'
import html from '../../../Assets/Icons/html.png'
import css from '../../../Assets/Icons/css.png'
import javascript from '../../../Assets/Icons/javascript_logo-freelogovectors.net_.png'
import react from '../../../Assets/Icons/react.png'
import tailwind from '../../../Assets/Icons/tailwind.png'
import bootstrap from '../../../Assets/Icons/bootstrap.png'
import typescript from '../../../Assets/Icons/typescript.png'
import mongodb from '../../../Assets/Icons/mongodb.png'
import postman from '../../../Assets/Icons/postman.png'
import figma from '../../../Assets/Icons/figma.png'
import git from '../../../Assets/Icons/github.png'
import materialUi from '../../../Assets/Icons/material ui.png'

const Skills = () => {
    return (
        <div className='lg:mt-10 lg:pt-28 md:mt-5 px-2 w-screen lg:w-full' id='skills'>
            {/* <div className='px-2 w-screen lg:w-full' id='skills'> */}
            <h1 className='skills-heading-style text-3xl ml-5 lg:ml-0 md:text-4xl font-semibold mb-20 mt-32 lg:mt-0'>My Fields of
                specialization</h1>
            {/* <div className='flex flex-col md:flex-row justify-evenly gap-5'>
                <div className='w-full md:w-6/12 h-full skills-styles p-5 rounded-xl'>
                    <h2 className='text-2xl font-bold text-center mb-7'>Frontend</h2>
                    <div className=''>
                        <div className='flex justify-around text-5xl text-center'>
                            <div><FaReact className='hover:text-sky-500' /></div>
                            <div><SiTailwindcss className='hover:text-sky-500' /></div>
                            <div><FaBootstrap className='hover:text-purple-600' /></div>
                        </div>
                        <div className='flex justify-evenly text-5xl mt-5'>
                            <div><FaCss3Alt className='hover:text-sky-700' /></div>
                            <div><FaHtml5 className='hover:text-orange-600' /></div>
                        </div>
                    </div>
                </div>
                <div className='w-full md:w-6/12'>
                    <div className=' w-full skills-styles h-52 p-5 rounded-xl'>
                        <h2 className='text-2xl font-bold text-center mb-7'>Others</h2>
                        {/* <div className='flex justify-around mt-12'>
                            <img src={firebase} className= grayscale hover:grayscale-0" alt="" />
                            <img src={varcel} className="w-2/12 grayscale hover:grayscale-0" alt="" />
                            <img src={netlify} className= grayscale hover:grayscale-0" alt="" />
                            <span><BsGithub className='text-5xl text-gray-700 hover:text-black' /></span>
                        </div> */}
            {/* </div>
                </div >



            </div >
    <div className='flex flex-col md:flex-row h-56 gap-5 mt-5' data-aos="fade-up">
        <div className='w-full skills-styles  p-5 rounded-xl'>
            <h2 className='text-2xl font-bold text-center mb-7 '>Backend</h2>
            <div className='flex justify-around'>
                <img src={node} className="w-2/12 mr-5 mt-5 grayscale hover:grayscale-0 " alt="" />
                <img src={express} className="w-2/12 mt-5 grayscale hover:grayscale-0" alt="" />
            </div>
        </div>
        <div className='w-full skills-styles p-5 rounded-xl '>
            <h2 className='text-2xl font-bold text-center mb-7'>Database</h2>
            <div className='flex justify-around'>
                <img src={mongodb} className="w-7/12 mr-5 mt-5 grayscale hover:grayscale-0" alt="" />
            </div>
        </div>
        <div className='w-full skills-styles p-5 rounded-xl'>
            <h2 className='text-2xl font-bold text-center mb-7'>Programming languages</h2>
            <div className='flex justify-around mt-12'>
                <span><SiJavascript className='text-5xl rounded-2xl hover:text-yellow-500' /></span>
                <span><SiTypescript className='text-5xl rounded-2xl hover:text-sky-700' /></span>

            </div>
        </div>
    </div>  */}
            <div>
                {/* Large & Small */}
                <div className='block md:hidden lg:flex justify-around'>
                    <div data-aos="fade-down">
                        <h3 className='text-2xl font-semibold mb-8 text-center'>Frontend</h3>

                        <div className='flex justify-around'>
                            <div className='' >
                                <div className='flex gap-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={html} alt="" />
                                        </div>
                                        <h5 className='font-semibold text-base mt-2'>HTML</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={css} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>CSS</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[41px] mx-auto' src={javascript} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Javascript</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>
                                </div>

                                <div className='flex gap-10 mt-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={react} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>React</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={tailwind} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Tailwind</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={bootstrap} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Bootstrap</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>


                                </div>

                                <div className='flex justify-center gap-10 mt-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={typescript} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Typescript</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={materialUi} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Material UI</h5>
                                        <p className='font-light'>Basic</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div data-aos="fade-down">
                        <h3 className='text-2xl font-semibold mt-14 lg:mt-0 mb-8 text-center'>Backend</h3>

                        <div data-aos="fade-out">
                            <div>
                                <div className='flex justify-center gap-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={node} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Node Js</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[26px] mx-auto' src={express} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Express Js</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center lg:mt-10 inline-block lg:hidden'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={mongodb} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>MongoDB</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                </div>

                                <div className=' hidden lg:flex justify-center gap-10'>

                                    <div className='text-center mt-10'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={mongodb} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>MongoDB</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className='mt-14 lg:mt-0' data-aos="fade-down">
                            <h3 className='text-2xl font-semibold mb-8 text-center'>Others</h3>
                            <div className='flex justify-center gap-10 mt-5'>
                                <div className='text-center'>
                                    <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                        <img className='w-[30px] mx-auto' src={figma} alt="" />
                                    </div>
                                    <h5 className='font-semibold mt-2'>Figma</h5>
                                    <p className='font-light'>Intermidiate</p>
                                </div>

                                <div className='text-center'>
                                    <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                        <img className='w-[30px] mx-auto' src={git} alt="" />
                                    </div>
                                    <h5 className='font-semibold mt-2'>Git</h5>
                                    <p className='font-light'>Intermidiate</p>
                                </div>

                                <div className='text-center'>
                                    <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                        <img className='w-[30px] mx-auto' src={postman} alt="" />
                                    </div>
                                    <h5 className='font-semibold mt-2'>Postman</h5>
                                    <p className='font-light'>Intermidiate</p>
                                </div>


                            </div>
                            <div className='flex justify-center gap-10 mt-8'>
                                <div className='text-center'>
                                    <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                        <img className='w-[30px] mx-auto' src={netlify} alt="" />
                                    </div>
                                    <h5 className='font-semibold mt-2'>Netlify</h5>
                                    <p className='font-light'>Intermidiate</p>
                                </div>

                                <div className='text-center'>
                                    <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                        <img className='w-[30px] mx-auto' src={firebase} alt="" />
                                    </div>
                                    <h5 className='font-semibold mt-2'>Firebase</h5>
                                    <p className='font-light'>Intermidiate</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div >

                {/* Medium */}
                <div className='hidden md:flex lg:hidden justify-around'>
                    <div data-aos="fade-down">
                        <h3 className='text-2xl font-semibold mb-8 text-center'>Frontend</h3>

                        <div className='flex justify-around'>
                            <div className='' >
                                <div className='flex gap-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={html} alt="" />
                                        </div>
                                        <h5 className='font-semibold text-base mt-2'>HTML</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={css} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>CSS</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[41px] mx-auto' src={javascript} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Javascript</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>
                                </div>

                                <div className='flex gap-10 mt-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={react} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>React</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={tailwind} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Tailwind</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={bootstrap} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Bootstrap</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>


                                </div>

                                <div className='flex justify-center gap-10 mt-10'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={typescript} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Typescript</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={materialUi} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Material UI</h5>
                                        <p className='font-light'>Basic</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div data-aos="fade-down">
                            <h3 className='text-2xl font-semibold lg:mt-0 mb-8 text-center'>Backend</h3>

                            <div data-aos="fade-out">
                                <div>
                                    <div className='flex justify-center gap-10'>
                                        <div className='text-center'>
                                            <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                                <img className='w-[30px] mx-auto' src={node} alt="" />
                                            </div>
                                            <h5 className='font-semibold mt-2'>Node Js</h5>
                                            <p className='font-light'>Intermidiate</p>
                                        </div>

                                        <div className='text-center'>
                                            <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                                <img className='w-[26px] mx-auto' src={express} alt="" />
                                            </div>
                                            <h5 className='font-semibold mt-2'>Express Js</h5>
                                            <p className='font-light'>Intermidiate</p>
                                        </div>

                                        <div className='text-center lg:mt-10 inline-block lg:hidden'>
                                            <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                                <img className='w-[30px] mx-auto' src={mongodb} alt="" />
                                            </div>
                                            <h5 className='font-semibold mt-2'>MongoDB</h5>
                                            <p className='font-light'>Intermidiate</p>
                                        </div>

                                    </div>

                                    <div className=' hidden lg:flex justify-center gap-10'>

                                        <div className='text-center mt-10'>
                                            <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                                <img className='w-[30px] mx-auto' src={mongodb} alt="" />
                                            </div>
                                            <h5 className='font-semibold mt-2'>MongoDB</h5>
                                            <p className='font-light'>Intermidiate</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='mt-8 lg:mt-0' data-aos="fade-down">
                                <h3 className='text-2xl font-semibold mb-8 text-center'>Others</h3>
                                <div className='flex justify-center gap-10 mt-5'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={figma} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Figma</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={git} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Git</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={postman} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Postman</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>


                                </div>
                                <div className='flex justify-center gap-10 mt-8'>
                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={netlify} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Netlify</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                    <div className='text-center'>
                                        <div className='bg-gray-200 rounded-full py-5 w-[65px] mx-auto text-center skills'>
                                            <img className='w-[30px] mx-auto' src={firebase} alt="" />
                                        </div>
                                        <h5 className='font-semibold mt-2'>Firebase</h5>
                                        <p className='font-light'>Intermidiate</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </div >
    );
};

export default Skills;